import Logger from '~/utils/logger/logger';

export type Callback = (...args) => any;
type UnsubscribeCallback = () => void;

export default class PubSub {
  private events: { [key: string]: Callback[] } = {};
  private onceEvents: { [key: string]: Callback[] } = {};

  on(event: string, callback: Callback, doLog = true): UnsubscribeCallback {
    if (doLog) {
      Logger.log('Subscribing to event', event);
    }
    this.events[event] = this.events[event] || [];
    this.events[event].push(callback);

    return () => {
      this.off(event, callback, doLog);
    };
  }

  once(event: string, callback: Callback): UnsubscribeCallback {
    Logger.log('Subscribing once to event', event);
    this.onceEvents[event] = this.onceEvents[event] || [];
    this.onceEvents[event].push(callback);

    return () => {
      this.off(event, callback);
    };
  }

  off(event: string, callback?: Callback, doLog = true): void {
    if (doLog) {
      Logger.log('Unsubscribing from event', event);
    }
    if (!this.events[event] && !this.onceEvents[event]) {
      return;
    }

    //No callback defined, remove all callbacks from this event
    if (!callback) {
      delete this.events[event];
      delete this.onceEvents[event];
      return;
    }

    this.events[event] = this.events[event]?.filter((cb) => cb !== callback);
    this.onceEvents[event] = this.onceEvents[event]?.filter((cb) => cb !== callback);
  }

  emit(event: string, data?: any): void {
    this.events[event]?.forEach((e) => e(data));
    this.onceEvents[event]?.forEach((e) => e(data));
    delete this.onceEvents[event];
  }
}

export const pubSub = new PubSub();
